<div class="root-content-wrapper" [style.background]="sessionService.bgColor$|async">

    <app-navbar *ngIf="rootService.navbarVisible$|async"></app-navbar>

    <div class="main-content">

        <div class="scrollable-inner">
            <router-outlet></router-outlet>
        </div>

        <div class="newsfeed"  @show *ngIf="newsfeedService.newsfeedVisible$|async">

            <app-newsfeed></app-newsfeed>

        </div>
    
    </div>

    <div *ngIf="sessionService.loggedIn$|async" class="online-users-footer" [class.newsfeed-visible]="newsfeedService.newsfeedVisible$|async" [matMenuTriggerFor]="onlineUsers">

        <mat-icon class="online-indicator">lens</mat-icon>

        <div>
            Nutzer online
        </div>

        <div class="online-counter">{{(userService.online$|async).length}}</div>

    </div>

    <div class="loading-overlay" *ngIf="!(sessionService.ready$|async)" @hide>

        <mat-spinner diameter="100"></mat-spinner>

    </div>

</div>

<input appUploadInput type="file" accept="*" style="display: none;" multiple="multiple" />

<mat-menu #onlineUsers="matMenu">

    <div class="online-user-menu-content">

        <div class="online-user-wrapper" *ngFor="let user of (userService.online$|async)">

            <app-user-preview2 [user]="user"></app-user-preview2>
    
        </div>

    </div>

</mat-menu>
